// Simulated history totals use verified settlement observations, never result-label guesses.
import type { PbWeekSummary } from './usePowerballHistory.ts';
export interface PowerballHistoryStats {
 settledStake:number;settledTickets:number;totalAttempts:number;jackpots:number;nearMisses:number;avgCorrectLegs:number|null;totalStaked:number;totalReturned:number;
}
export function computePowerballHistoryStats(weeks:readonly PbWeekSummary[]):PowerballHistoryStats {
 let settledStake=0,settledTickets=0,totalAttempts=0,jackpots=0,nearMisses=0,totalStaked=0,totalReturned=0,won=0,observed=0;
 for(const w of weeks)for(const side of ['pb10','mega'] as const){
  if(!w[`${side}_status`])continue;totalAttempts++;totalStaked+=w[`${side}_stake`]??0;
  const result=w[`${side}_result`];if(result==='jackpot')jackpots++;else if(result?.startsWith('near_miss'))nearMisses++;
  if(w[`${side}_status`]==='settled'){
   const payout=w[`${side}_realized_return`];if(typeof payout==='number'){totalReturned+=payout;settledStake+=w[`${side}_stake`]??0;settledTickets++;}
   const count=w[`${side}_won_count`];if(typeof count==='number'){won+=count;observed++;}
  }
 }
 return {settledStake,settledTickets,totalAttempts,jackpots,nearMisses,avgCorrectLegs:observed?won/observed:null,totalStaked,totalReturned};
}
